






























import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import TransferInstanceTrigger from './TransferInstanceTrigger.coffee'

settings =
  name: 'TransferInstanceTriggerModal'
  resources:

    event_set:
      resourceName: 'event_set'
      slug: 'event_sets/:currentEventSetId'
      fetch: false

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton, LoadingIndicator }
    mixins: [TransferInstanceTrigger.trigger()]

    computed:
      modalConfig: -> @modal.config || {}
      currentEventSetId: -> @modalConfig.currentEventSetId
      events: -> @event_set?.events || []
      avaliableInstances: ->
        (@events).filter((instance) =>
          instance.id isnt @modalConfig.currentInstanceId
        )

    methods:
      formatLocalStartDay: (instance) ->
        return @$options.filters.formatDate(instance.local_start_day)

export default VueOptions.vue settings
